<template> 
    <div class="agToggle" :class="{'agToggle_disabled': disabled}" @click="agToggle_click" :key="on">
        <div 
            class="agToggle-container" 
            :class="{'on': on}">
                <div class="agToggle-button">
                </div>
        </div>
        <div class="agToggle-label" :class="labelClass">{{label}}</div>
  </div>
</template>


<script>

// components

// modules

export default {
  name: "ag-toggle",
  props:{
      label: String,
      labelPosition: String,
      on: Boolean,
      disabled: Boolean
  },
  data() {
    return {
    };
  },
  computed: {

      labelClass()
      {
          if(this.labelPosition == "left")
          {
              return "agToggle-labelLeft";
          }
          else if(this.labelPosition == "right")
          {
            return "agToggle-labelRight";
          }
          else if(this.labelPosition == "top")
          {
            return "agToggle-labelTop";
          }
          else
          {
            return "agToggle-labelBottom";
          }
      }
  },
  methods: {
    agToggle_click()
    {
        if(!this.disabled)
            this.$emit("toggled");
    }
  }
};
</script>




<style scoped lang="css">

.agToggle 
{
  display: inline-block;
}

.agToggle_disabled {
    opacity: 0.5;
}
  
.agToggle-container 
{
    display: inline-block;
    width: 50px;
    height: 25px;
    background-color: #C82333;
    border-radius: 5px;    

    transition: all 0.3s ease-in-out;
    cursor: pointer;
}

.agToggle_disabled .agToggle-container {
    cursor: no-drop;
}

.agToggle-button 
{
    position: relative;
    width: 20px;
    height: 20px;
    top: 2.5px;
    left: 3px;
    background-color: #FFFFFF;
    border-radius: 5px;

    transition: all 0.3s ease-in-out;
}

.agToggle-container.on {
    background-color: #28A745;
}


.agToggle-container.on .agToggle-button
{
    transform: translate(23px);
}

.agToggle-label 
{
    display: inline-block;
    margin-top: 2px;
    font-size: 16px;
}

.agToggle-labelLeft
{
    float: left;
    margin-right: 5px;
}

.agToggle-labelRight
{
    float: right;
    margin-left: 5px;
}

.agToggle-labelTop
{
    display: block;
    margin-top: -55px;
}

.agToggle-labelBottom
{
    display: block;
    margin-top: -5px;
}



</style>



// WEBPACK FOOTER //
// src/components/ui/Toggle.vue